import { isBarcodeBlock } from '../template-editor/component/basic-blocks/barcode/utils';
import { isImageBlock } from '../template-editor/component/basic-blocks/image/utils';
import { isQrcodeBlock } from '../template-editor/component/basic-blocks/qrcode/utils';
import { isSignatureBlock } from '../template-editor/component/basic-blocks/signature/utils';
import { UploadImageBlockProps } from '../template-editor/component/basic-blocks/upload-image/type';
import { isUploadImageBlock } from '../template-editor/component/basic-blocks/upload-image/utils';
import { isValueBlock } from '../template-editor/component/basic-blocks/value/utils';
import {
  BlockProps,
  IMappingKey,
} from '../template-editor/component/content-blocks/type';

export function getValue(obj: Record<string, any>, key: IMappingKey): any {
  if (Array.isArray(key)) {
    return key.reduce((acc, cur) => acc && acc[cur], obj);
  }

  return obj[key];
}

export const mapValueToBlock = (
  block: BlockProps,
  values?: Record<string, any>,
): BlockProps => {
  if (isValueBlock(block) || isBarcodeBlock(block) || isQrcodeBlock(block)) {
    return {
      ...block,
      value: values ? getValue(values, block.mappingKey) : block.value,
    };
  }

  if (isUploadImageBlock(block)) {
    const mappingValue = block?.mappingKey;
    const url = block?.[mappingValue as keyof UploadImageBlockProps];
    return {
      ...block,
      url,
    };
  }
  if (isImageBlock(block)) {
    return {
      ...block,
      // url: values ? getValue(values, block.mappingKey) : block.url,
      ...(!block?.isUpload && {
        url: values ? getValue(values, block.mappingKey) : block.url,
      }),
    };
  }
  if (isSignatureBlock(block)) {
    const signatureData = values?.signatures?.find(
      (signature: any) => signature.position === block.mappingKey,
    );
    if (signatureData) {
      const { name, signature_url } = signatureData;
      const blockWithData = {
        ...block,
        // nmc,
        // nhpc_no,
        // caption,
        name,
        // specialization: specialities,
        // specialities,
        // qualification,
        imageUrl: signature_url,
        label: '',
      };
      return blockWithData;
    }
    return { ...block, isVisible: false };
  }
  return block;
};

export const mapValueToBlocks = (
  blocks: Array<BlockProps>,
  values: { [key: string]: any },
): Array<BlockProps> => {
  const updatedBlocks = blocks.map((block) => mapValueToBlock(block, values));
  return updatedBlocks;
};
